/**
 * Contact information constants
 * Centralized location for contact details to avoid duplication
 */

export const CONTACT_EMAIL = 'iampaolotodde@gmail.com';

export const CONTACT_INFO = {
   email: CONTACT_EMAIL,
   title: "Let's connect!",
   description: '',
   buttonLabel: 'Send a message',
};
